import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type Input = {
  tripFolderId: number
  transferId: number
}

export function unassignTransferFromTripFolder(data: Input) {
  const { tripFolderId, transferId } = data

  return restApiClient
    .url(constructApiUrl(API.tripFolder.unassignTransfer.url, { id: tripFolderId, transferId }))
    .delete()
}
